import { ResourceOptions } from 'react-admin';
import { FaCircleNotch } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxLuckyWheel;
export const icon = FaCircleNotch;
export const options: ResourceOptions = {
  label: 'module.blindBox.luckyWheel',
};
